import { render, staticRenderFns } from "./ProjectBudget.vue?vue&type=template&id=38ff3239&scoped=true"
import script from "./ProjectBudget.vue?vue&type=script&lang=js"
export * from "./ProjectBudget.vue?vue&type=script&lang=js"
import style0 from "./ProjectBudget.vue?vue&type=style&index=0&id=38ff3239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff3239",
  null
  
)

export default component.exports